import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'AppEntry/App.css';
// APPS
import GetNext from 'components/apps/GetNext';
import InStock from 'components/apps/InStock';
// ROUTES
import { Auth } from 'components/common/Auth/Auth';
import { HandleAuth } from 'components/common/Auth';
import * as ROUTES from 'components/common/Routes';
// HOCs
import { withFirebaseProvider } from 'components/common/Firebase';
// COMPONENTS
import Landing from 'components/common/Landing';
import RouteWrapper from 'components/common/RouteWrapper'; // will just render whatever you give it, agnostic to if user is authenticated or not
import BlankLayout from 'components/layout/BlankLayout';
import PublicLayout from 'components/layout/PublicLayout';

let notifications;

export const addNotification = (title, body, color = '', params = {}) => {
  //EXAMPLE OF ADD NOTIFICATION FUNCTION
  // notifications.addNotification('Title', 'Some random body text', 'warning', {position: 'top-right'})
  // notifications.addNotification('Title', 'Some random body text', '#fff')
  // notifications.addNotification('Title', 'Some random body text')
  notifications.addNotification(title, body, color, params);
};

const SignUp = props => <Auth {...props} initialVisibilityFilter="sign up" />;

class View extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <RouteWrapper
            exact={true}
            path={ROUTES.AUTH}
            component={Auth}
            layout={PublicLayout}
          />
          <RouteWrapper
            exact={true}
            path={ROUTES.HANDLE_AUTH}
            component={HandleAuth}
            layout={BlankLayout}
          />
          <RouteWrapper
            exact={true}
            path={ROUTES.GET_NEXT}
            component={GetNext}
            layout={PublicLayout}
          />
          <RouteWrapper
            exact={true}
            path={ROUTES.IN_STOCK}
            component={InStock}
            layout={BlankLayout}
          />
          <RouteWrapper
            exact={true}
            path={'/in-stock/:param'}
            component={InStock}
            layout={BlankLayout}
          />
          <RouteWrapper
            exact={true}
            path={ROUTES.LANDING}
            component={Landing}
            layout={PublicLayout}
          />
          <RouteWrapper
            path={ROUTES.SIGN_UP}
            layout={PublicLayout}
            component={SignUp}
          />
        </Switch>
      </Router>
    );
  }
}

export default withFirebaseProvider(View);
